import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// import i18next from 'i18next';
// import moment from 'moment'

export interface Language {
	code: string;
	lng_code: string;
	lng_title_native: string;
	active?: boolean;
	default?: boolean;
}

const languages: Record<string, Language> = {
	ar: { code: "ar", lng_code: "LANG_AR", lng_title_native: "عربي" },
	bn: {
		code: "bn",
		lng_code: "LANG_BN",
		lng_title_native: "বাংলা",
		active: true,
	},
	ca: {
		code: "ca",
		lng_code: "LANG_CA",
		lng_title_native: "Català",
		active: true,
	},
	cs: {
		code: "cs",
		lng_code: "LANG_CS",
		lng_title_native: "Česky",
		active: true,
	},
	da: {
		code: "da",
		lng_code: "LANG_DA",
		lng_title_native: "Dansk",
		active: true,
	},
	de: {
		code: "de",
		lng_code: "LANG_DE",
		lng_title_native: "Deutsch",
		active: true,
	},
	en: {
		code: "en",
		lng_code: "LANG_EN",
		lng_title_native: "English",
		active: true,
		default: true,
	},
	es: {
		code: "es",
		lng_code: "LANG_ES",
		lng_title_native: "Español",
		active: true,
	},
	fi: {
		code: "fi",
		lng_code: "LANG_FI",
		lng_title_native: "Suomi",
		active: true,
	},
	fr: {
		code: "fr",
		lng_code: "LANG_FR",
		lng_title_native: "Français",
		active: true,
	},
	hr: { code: "hr", lng_code: "LANG_HR", lng_title_native: "Hrvatski" },
	hu: {
		code: "hu",
		lng_code: "LANG_HU",
		lng_title_native: "Magyar",
		active: true,
	},
	it: {
		code: "it",
		lng_code: "LANG_IT",
		lng_title_native: "Italiano",
		active: true,
	},
	ja: {
		code: "ja",
		lng_code: "LANG_JA",
		lng_title_native: "日本語",
		active: true,
	},
	ko: {
		code: "ko",
		lng_code: "LANG_KO",
		lng_title_native: "한국어",
		active: true,
	},
	nl: {
		code: "nl",
		lng_code: "LANG_NL",
		lng_title_native: "Nederlands",
		active: true,
	},
	no: {
		code: "no",
		lng_code: "LANG_NO",
		lng_title_native: "Norsk",
		active: true,
	},
	pl: {
		code: "pl",
		lng_code: "LANG_PL",
		lng_title_native: "Polskie",
		active: true,
	},
	pt: {
		code: "pt",
		lng_code: "LANG_PT_PT",
		lng_title_native: "Portuguese",
		active: true,
	},
	"pt-BR": {
		code: "pt-BR",
		lng_code: "LANG_PT_BR",
		lng_title_native: "Portuguese (BR)",
		active: true,
	},
	ru: {
		code: "ru",
		lng_code: "LANG_RU",
		lng_title_native: "Русский",
		active: true,
	},
	sv: {
		code: "sv",
		lng_code: "LANG_SV",
		lng_title_native: "Svenska",
		active: true,
	},
	sk: { code: "sk", lng_code: "LANG_SK", lng_title_native: "Slovák" },
	uk: {
		code: "uk",
		lng_code: "LANG_UK",
		lng_title_native: "Український",
		active: true,
	},
	he: { code: "he", lng_code: "LANG_HE", lng_title_native: "" }, // deactivated
	hi: {
		code: "hi",
		lng_code: "LANG_HI",
		lng_title_native: "हिंदी",
		active: true,
	},
	vi: { code: "vi", lng_code: "LANG_VI", lng_title_native: "" }, // deactivated
	"zh-Hans": {
		code: "zh-Hans",
		lng_code: "LANG_ZH_HANS",
		lng_title_native: "简体中文",
		active: true,
	},
	"zh-Hant": {
		code: "zh-Hant",
		lng_code: "LANG_ZH_HANT",
		lng_title_native: "繁體中文",
		active: true,
	},
};

const supportedLngs: string[] = [];

Object.entries(languages).forEach(([key, value]) => {
	if (value.active) {
		supportedLngs.push(value.code);
	}
});

let loadPath = "";
if (typeof window === "undefined") {
	// chrome backend worker
	loadPath = "/data/translations/locale-{{lng}}.json";
} else {
	loadPath = "./translations/locale-{{lng}}.json";
}

i18n
	// load translation using xhr -> see /public/locales
	// learn more: https://github.com/i18next/i18next-xhr-backend
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: "en",
		supportedLngs: supportedLngs,
		load: "all",
		debug: process.env.NODE_ENV === "development",
		backend: {
			// for all available options read the backend's repository readme file
			loadPath: loadPath,
		},

		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
	});

export { i18n as default, languages };
